import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  AllVehicleTypeDetails,
  CreateVehicleTypeDetails,
  UpdateVehicleTypeDetails,
} from "../../Apis/vehicleApi";
import { AllCollectionTypeDetails } from "../../Apis/collectionTypeApi";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { TableLoader } from "../../Common/ShimmerLoader";
import { withTranslation } from "react-i18next";
import * as XLSX from "xlsx";

const ContainerType = ({ t }) => {
  const headers = [
    "collectionType",
    "vehicleTypeCode",
    "vehicleType",
    "status",
    "actions",
  ];
  const [lgShow, setLgShow] = useState(false);
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [collectionTypeDetails, setCollectionTypeDetails] = useState([]);
  const [editVehicleTypeData, setEditVehicleTypeData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [collectionDetails, setCollectionDetails] = useState([]);

  const [formInput, setFormInput] = useState({
    vehicleTypeName: "",
    collectionTypeId: "",
    vehicleTypeCode: "",
    isActive: true,
  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Sanitize input based on field name
    switch (name) {
      case "vehicleTypeName":
        // Allow only alphabetical characters and spaces
        const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

        setFormInput((prevData) => ({ ...prevData, [name]: sanitizedValue }));
        break;
      case "collectionTypeId":
        // If it's a radio button, set the value to 1 or 0 based on the selected radio button
        const intValue = parseInt(value, 10);

        const selectedCollectionType = collectionTypeDetails.find(
          (type) => type.collectionTypeId === intValue
        );
        setFormInput((prevData) => ({
          ...prevData,
          [name]: intValue,
          collectionTypeName: selectedCollectionType
            ? selectedCollectionType.collectionTypeName
            : "",
        }));
        break;
      case "vehicleTypeCode":
        // Allow only alphanumeric characters for the vehicle type code
        const sanitizedCode = value.replace(/[^a-zA-Z0-9-]/g, "").toUpperCase();
        setFormInput((prevData) => ({ ...prevData, [name]: sanitizedCode }));
        break;
      default:
        setFormInput((prevData) => ({ ...prevData, [name]: value }));
        break;
    }
  };

  const handleClose = () => {
    setFormInput({
      vehicleTypeName: "",
      collectionTypeId: "",
      vehicleTypeCode: "",
      isActive: "",
    });
    setLgShow(false); // Explicitly set lgShow to false
    setFormSubmitted(false);
  };

  const handleShow = () => {
    setLgShow(true);
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 1000);
    setFormInput({
      id: "",
      vehicleTypeName: "",
      vehicleTypeCode: "",
      isActive: true,
      collectionTypeId: "",
    });
    setEditVehicleTypeData(null);
  };

  // Inside handleEditVehicleTypeData function, set collection type name in formInput state
  const handleEditVehicleTypeData = (selectedVehicleTypeDetails) => {
    setEditVehicleTypeData(selectedVehicleTypeDetails);
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 1000);
    setFormInput({
      vehicleTypeId: selectedVehicleTypeDetails.vehicleTypeId,
      vehicleTypeCode: selectedVehicleTypeDetails.vehicleTypeCode,
      vehicleTypeName: selectedVehicleTypeDetails.vehicleTypeName,
      collectionTypeId: selectedVehicleTypeDetails.collectionTypeId,
      collectionTypeName: selectedVehicleTypeDetails.collectionTypeName, // Include collection type name
      isActive: selectedVehicleTypeDetails.isActive,
    });
    setLgShow(true);
  };

  const vehcileTypeData = async () => {
    try {
      setIsLoading(true);
      const response = await AllVehicleTypeDetails();
      setVehicleTypeDetails(response);
    } catch (error) {
      console.error("Error fetching shift data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const collectionTypeData = async () => {
    try {
      setIsLoading(true);
      const response = await AllCollectionTypeDetails();
      setCollectionTypeDetails(response);
    } catch (error) {
      console.error("Error fetching shift data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(
    () => {
      vehcileTypeData();
      collectionTypeData();
    },
    []
    // [lgShow]
  );

  const handleCreateVehicleTypeDetails = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    try {
      setIsLoading(true);

      // Check if editVehicleTypeData is present (indicating update mode)
      if (editVehicleTypeData) {
        // Perform validation for required fields only when adding new data
        if (
          !formInput.vehicleTypeName ||
          !formInput.collectionTypeId ||
          !formInput.vehicleTypeCode
        ) {
          // toast.error("Please fill in all required fields.", {
          //   position: "top-right",
          //   autoClose: 5000,
          //   hideProgressBar: false,
          // });
          return;
        }

        // Check for duplicate vehicle type code
      }

      // const isDuplicateCode = vehicleTypeDetails.some(
      //   (type) => type.vehicleTypeCode === formInput.vehicleTypeCode
      // );
      // if (isDuplicateCode) {
      //   toast.error(
      //     "Vehicle Type Code already exists. Please choose a different one.",
      //     {
      //       position: "top-right",
      //       autoClose: 5000,
      //       hideProgressBar: false,
      //     }
      //   );
      //   return;
      // }

      // Handle update or creation based on editVehicleTypeData presence
      if (editVehicleTypeData) {
        // Update existing vehicle type details
        const updatedVehicleTypeData = { ...formInput };
        const response = await UpdateVehicleTypeDetails(updatedVehicleTypeData);
        setVehicleTypeDetails([...vehicleTypeDetails, response]);
        toast.success("Vehicle Type Details updated successfully");
        fetchAllVehicleTypeDetails();
        handleClose();
      } else {
        // Add new vehicle type details
        const response = await CreateVehicleTypeDetails(formInput);
        toast.success("Vehicle Type Details created successfully");
        fetchAllVehicleTypeDetails();
        handleClose();
      }
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          // Handle 400 status code errors with validation errors
          const validationErrors = data;
          // for (const field in validationErrors) {
          toast.error(validationErrors, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
          // }
        } else if (status === 409) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else {
          // Handle other status code errors
          toast.error("An error occurred. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      } else {
        // Handle network errors or other unexpected errors
        toast.error("An error occurred. Please try again later.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
      }
    } finally {
      setIsLoading(false); // Set loading back to false after API call completes
    }
  };


  const fetchAllVehicleTypeDetails = async () => {
    const [collectionPointDetails, vehicleTypeResponse] = await Promise.all([
      AllCollectionTypeDetails(),
      AllVehicleTypeDetails(),
    ]);
    const collectionPointTypeData = vehicleTypeResponse.map((station) => {
      const vehicleTypes = vehicleTypeResponse.find(
        (vehicleType) => vehicleType.vehicleTypeId === station.vehicleTypeId
      );
      const collectionTypes = collectionPointDetails.find(
        (collectionType) =>
          collectionType.collectionTypeId === station.collectionTypeId
      );

      return {
        ...station,
        vehicleType: vehicleTypes ? vehicleTypes.vehicleTypeName : "N/A",
        collectionType: collectionTypes
          ? collectionTypes.collectionTypeName
          : "N/A",
        status: station.isActive ? "Active" : "InActive",
        // zone: zone ? zone.zoneName : "N/A",
        // circle: circle ? circle.circleName : "N/A",
      };
    });

    // Sort the data based on the isActive field
    const sortedRouteData = collectionPointTypeData.sort((a, b) => {
      if (a.isActive === b.isActive) {
        return 0;
      }
      return a.isActive ? -1 : 1;
    });

    setCollectionDetails(sortedRouteData);
  };

  useEffect(() => {
    fetchAllVehicleTypeDetails();
  }, []);


  const downloadAsExcel = () => {
    // Add serial number to each item in the collection details
    const dataWithSerialNumber = collectionDetails.map((item, index) => ({
      ...item,
      's.no': index + 1,
    }));

    // Filter out only the data corresponding to the headers displayed in the table component
    const filteredData = dataWithSerialNumber.map(item => ({
      's.no': item['s.no'],
      collectionType: item.collectionType,
      vehicleTypeCode: item.vehicleTypeCode,
      vehicleType: item.vehicleType,
      status: item.status,
    }));

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "VehicleTypeData");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(data);
    downloadLink.download = "VehicleTypeData.xlsx";
    downloadLink.click();
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="text-end mb-3">
                <button className="button-container" onClick={handleShow}>
                  <i className="fa-solid fa-plus me-1 icon-container"></i>
                  {t("addVehicleType")}
                </button>
              </div>
            </div>
            <div className="text-end mb-3">
              <button className="btn btn-danger"
                style={{ backgroundColor: "#EC1117" }} onClick={downloadAsExcel}>Download Excel</button>
            </div>
            <div className="card">
              <div className="card-body">
                <div className="top-header">
                  <span>{t("vehicleType")}</span>
                </div>
                <TableComponent isLoading={isLoading}
                  DataFetchURL={collectionDetails}
                  headers={headers}
                  filterFunction={(data) =>
                    data.filter(
                      (item) => item.status === 1 || item.status === 2
                    )
                  }
                  editData={handleEditVehicleTypeData} // Pass the callback function
                  editDataDetails={editVehicleTypeData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {editVehicleTypeData ? t("editVehicleType") : t("addVehicleType")}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form onSubmit={handleCreateVehicleTypeDetails}>
            <div className="row">
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("Collection Type Name")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    name="collectionTypeId"
                    className={`form-select ${formInput.collectionTypeId || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    onChange={handleInputChange}
                    value={formInput.collectionTypeId} // Set value from formInput state
                  >
                    <option value="">Select</option>
                    {/* Map through collection types and render options */}
                    {collectionTypeDetails.map((type) => (
                      <option
                        key={type.collectionTypeId}
                        value={type.collectionTypeId} // Make sure this value matches the collectionTypeId
                      >
                        {type.collectionTypeName}
                      </option>
                    ))}
                  </select>
                  {!formInput.collectionTypeId && formSubmitted && (
                    <div className="required-message">Collection Name is Required.</div>
                  )}
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("Vehicle Type Code")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="vehicleTypeCode"
                    className={`form-control ${formInput.vehicleTypeCode || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    placeholder="Enter VehicleType Code"
                    onChange={handleInputChange}
                    value={formInput.vehicleTypeCode}
                    maxLength={8}
                  />
                  {!formInput.vehicleTypeCode && formSubmitted && (
                    <div className="required-message">Vehicle Type Code is Required</div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("vehicleTypeName")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="vehicleTypeName"
                    className={`form-control ${formInput.vehicleTypeName || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    placeholder="Enter VehicleType Name"
                    onChange={handleInputChange}
                    value={formInput.vehicleTypeName}
                  />
                  {!formInput.vehicleTypeName && formSubmitted && (
                    <div className="required-message"> Vehicle Type Name is Required.</div>
                  )}
                </div>
              </div>

              <div className="col-md-4" style={{ marginTop: "5px" }}>
                <label className="form-label">
                  {t("status")}
                  <span style={{ color: "#EC1117" }}> *</span>
                </label>
                <div className="form-group" style={{ display: "flex" }}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="activeRadio"
                      checked={formInput.isActive} // Check if isActive is true
                      onChange={() =>
                        handleInputChange({
                          target: { name: "isActive", value: true }, // Set value to true
                        })
                      }
                    />

                    <label className="form-check-label" htmlFor="activeRadio">
                      Active
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "40px" }}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="inactiveRadio"
                      checked={formInput.isActive === false}
                      onChange={() =>
                        handleInputChange({
                          target: { name: "isActive", value: false }, // Set value to false
                        })
                      }
                    />

                    <label className="form-check-label" htmlFor="inactiveRadio">
                      InActive
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              <button type="submit" className="deployment-button">
                <i class="fa-solid fa-check done-container"></i>
                {editVehicleTypeData ? t("Update") : t("Save")}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(ContainerType);
